// TypeScript counterpart of libs/utils/src/configs/Config.res
// Reads from the same webpack-aliased 'Config' module (resolved via next.config.js)

interface WebsiteConfig {
  env: string;
  oms_url: string;
  cms_url: string;
  content_vault_url: string;
  wag_url: string;
  host: string;
  google_maps_api_key: string;
  google_recaptcha_api_key: string;
  sentry_dsn: string;
  ga4_tracking_id_ae: string;
  ga4_tracking_id_bd: string;
  ga4_tracking_id_tr: string;
  ga4_tracking_id_dom: string;
  kafka_api_url: string;
  customerCMSUrl: string;
  newInitiativesUrl: string;
  cag_url: string;
  sfmsUrl: string;
  hogsmeade_url: string;
  oms_internal_url: string;
  enable_gtm: boolean;
  gtm_code: string;
  enable_recaptcha: boolean;
  enable_enterprise_nudge?: boolean;
}

// Config is a webpack alias resolved at build time (see next.config.js)
// Server: CommonJS (module.exports = config), Client: ESM (export default window.__WEB_CONFIG__)
// eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires, no-undef
const configRaw = require('Config');
const configObj = (configRaw.default ?? configRaw) as WebsiteConfig;

export const env = configObj.env;
export const oms_url = configObj.oms_url;
export const cms_url = configObj.cms_url;
export const content_vault_url = configObj.content_vault_url;
export const newInitiativesUrl = configObj.newInitiativesUrl;
export const wag_url = configObj.wag_url;
export const google_maps_api_key = configObj.google_maps_api_key;
export const recaptcha_site_key = configObj.google_recaptcha_api_key;
export const host = configObj.host;
export const sfms_url = configObj.sfmsUrl;
export const hogsmeade_url = configObj.hogsmeade_url;
export const oms_internal_url = configObj.oms_internal_url;
export const enable_enterprise_nudge = configObj.enable_enterprise_nudge;

const _infra_stack = process.env['INFRA_STACK'];
if (!_infra_stack && process.env['NODE_ENV'] !== 'test') {
  throw new Error(
    'INFRA_STACK env variable is required. Build cannot proceed without it.',
  );
}
export const infra_stack: string = _infra_stack ?? '';

// ISR revalidation time in seconds. undefined = no ISR (static build only).
export const isrTime: number | undefined = undefined;
